import { PropsWithChildren } from 'react';

import { FlagsmithContext } from '@mint-lib/flags';
import { FlagsmithProviders } from '@mint-lib/flags-envs';

import { useInstance } from '../hooks/useInstance.js';

export interface FlagsmithProviderProps {
  name: keyof typeof FlagsmithProviders;
}

export function FlagsmithProvider({
  name,
  children,
}: PropsWithChildren<FlagsmithProviderProps>) {
  const [newFlagsmith] = useInstance('flagsmith', name);

  if (!newFlagsmith) {
    return null;
  }

  return (
    <FlagsmithContext.Provider value={newFlagsmith}>
      {children}
    </FlagsmithContext.Provider>
  );
}
